import styled, { css } from "styled-components";
import { FormControl, InputLabel, Select } from "@mui/material";

export const StyledFormControl = styled(FormControl)`
    &.MuiFormControl-root {
        min-width: 190px;
        max-width: 300px;
    }
`;

export const StyledInputLabel = styled(InputLabel)(
    ({ theme }) => css`
        &.MuiInputLabel-root {
            color: ${theme.palette.common.blue};
        }
        &.MuiInputLabel-shrink.Mui-focused {
            color: ${theme.palette.common.blue};
        }
    `
);

export const StyledSelect = styled(Select)(
    ({ theme }) => css`
        &.MuiInputBase-root {
            text-align: left;
            color: ${theme.palette.common.darkGray};
        }
        &.MuiInputBase-root.MuiInput-underline:after {
            border-color: ${theme.palette.common.blue};
        }
        &.MuiInputBase-root.MuiInput-underline:hover:not(.Mui-disabled):before {
            border-color: ${theme.palette.common.blue};
        }
    `
);
